import React from 'react';
import { Copy, FloaterTooltipMarkdown, Icon, Optional } from '@honda-canada/design-system-react';
import formatPrice, { roundUpParser } from '@honda-canada/js-utilities/lib/formatPrice';
import { useLanguage } from '../../../../utils/sitecoreContext';
import themeStyles from './ColorSwatchCarousel.styles';
const priceFormatter = (price, language) => formatPrice(price, language, 0, roundUpParser);
const UpChargePrice = themeStyles.apply(Copy, 'UpChargePrice');
const PLUS_SIGN = '+';
const PAYMENT_SEPARATOR = '/';
const ColorUpChargePrice = ({ price, payment, paymentFrequency, tooltipLabel }) => {
    const language = useLanguage();
    return (React.createElement(React.Fragment, null,
        React.createElement(Optional, { when: price },
            React.createElement(UpChargePrice, { size: "extraSmall", "data-testid": "cy-up-charge-price", ml: "-12px" },
                `${PLUS_SIGN} ${priceFormatter(price || 0, language)}`,
                React.createElement(FloaterTooltipMarkdown, { content: tooltipLabel, as: "span", styling: "light", "data-testid": "cy-color-up-charge-tooltip", ml: "xxs" }, ({ active }) => React.createElement(Icon, { name: "information", filled: active })))),
        React.createElement(Optional, { when: payment },
            React.createElement(Copy, { size: "extraSmall", color: "grey.0" },
                React.createElement("span", { "data-testid": "cy-up-charge-payment" }, formatPrice(payment, language, 2)),
                PAYMENT_SEPARATOR,
                React.createElement("span", { "data-testid": "cy-up-charge-payment-frequency" }, paymentFrequency)))));
};
export default ColorUpChargePrice;
